function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#DADADA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M39.5 22.25h-15c-1.657 0-3 1.268-3 2.833v19.834c0 1.564 1.343 2.833 3 2.833h15c1.657 0 3-1.269 3-2.833V25.083c0-1.564-1.343-2.833-3-2.833zM27.5 26h9M32 34.25v6M29 37.25h6"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 20,
  r: 2.75,
  stroke: "#4A4A4A",
  strokeWidth: 2
});

var SvgIndicationGrey = function SvgIndicationGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIndicationGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/indication_grey.b752f97a.svg";
export { ForwardRef as ReactComponent };